import angular from 'angular';
import commissionManagement from './commissionManagement';
import commissionDashboard from './commissionDashboard';

export default angular.module('commission.scenes', [
  commissionManagement,
  commissionDashboard,
]).name;
